import { useEffect } from "react";
import { isFeatureEnabled } from "../../utils/is-feature-enabled";
/**
 * This workarond allows the doordash button to be wiped away when visiting another url,
 * which replaces everything inside #__next.
 *
 * Using next/script appends the script to head, which persists when visiting another url.
 *
 * Using <script> tag directly in jsx does not render the button, even with defer attribute.
 *
 */
export const useDoordashButton = () => {
  useEffect(() => {
    if (isFeatureEnabled(process.env.NEXT_PUBLIC_ENABLE_DOORDASH)) {
      const script = document.createElement("script");
      script.src = "/doordash-store-front-cta-script.js";
      script.defer = true;
      const nextRoot = document.getElementById("__next");
      nextRoot.appendChild(script);
    }
  }, []);
};
